import { render, staticRenderFns } from "./elektrophile-substitution-mechanismus.vue?vue&type=template&id=530a5cf1&"
import script from "./elektrophile-substitution-mechanismus.vue?vue&type=script&lang=js&"
export * from "./elektrophile-substitution-mechanismus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports